import React, { useContext } from 'react';
import { useEntryStore } from '../../store/entry/entryStore';
import StartScreen from '../../components/Screens/StartScreen/StartScreen';
import ResultsScreen from '../../components/Screens/ResultsScreen/ResultsScreen';
import { useEventPoll } from '../../hooks/eventPoll/eventPoll';
import { useEntryPoll } from '../../hooks/entryPoll/entryPoll';
import { UserContext } from '@incentivegames/ig-frontend-common/lib/contexts/userContext';
import { usePredictorStore } from '../../store/predictor/predictorStore';
import { useGetPredictorStats } from '../../store/predictor/predictorActions';

const InPlayController = () => {
  const { user } = useContext(UserContext);
  const userToken = user.token;
  const predictor = usePredictorStore((s) => s.activePredictor);
  const entry = useEntryStore((s) => s.entry);

  useEventPoll(predictor?.eventGroupId, predictor?.marketCode);
  useEntryPoll(userToken, predictor?.predictorId);
  useGetPredictorStats(predictor?.predictorId);

  return entry ? <ResultsScreen /> : <StartScreen />;
};
export default InPlayController;
